export class CleanTransportDetails {
    archiveTransportEnabled: false;
    assignVehicleToStationEnabled: false;
}

export class CAssignVehicleToStation {
    transportId: number;
    stationId: number;
}

export class CheckSeResponse {
    hasEquipment = false;
}